//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  getCategoryIndex,
  getCategoryDetail
} from '../axios/index'
export default {
  data() {
    return {
      tablist:[
        {path:'/index',name:'首页',img:''},
        {path:'/explosion',name:'爆款秒杀',img:'data:image/gif;base64,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'},
        {path:'/enterprise',name:'企业回收',img:''},
        {path:'/aboutUs',name:'关于我们',img:''},
        // {path:'/evaluate',name:'客户说',img:''},
        {path:'/news',name:'新闻中心',img:''},
      ],
      categorylist: [],
      isshow:'none',
      path:''
    };
  },
  beforeCreate: async function() { //vuex测试
    let that = this;
    let categoryId = await getCategoryDetail();
    getCategoryIndex({
      id: categoryId.data.id
    }).then(function(res) {
      that.categorylist = res.data.children
    })
  },
  watch: {
    $route(to, from) {
      // 监听路由变化, 实现类似 小程序的 onShow 事件
      this.path = to.path
      if (to.path === '/index') {
        this.isshow = 'block'
      }else{
        this.isshow = 'none'
      }
    }
  },
  methods:{
    // 鼠标移入加入class
    changeActive($event){
      if (this.path != '/index') {
        this.isshow = 'block'
      }
    },
    removeActive($event){
      if (this.path != '/index') {
        this.isshow = 'none'
      }
    }
  }


}



// WEBPACK FOOTER //
// ./src/components/menu.vue